import DefaultAPIErrorHandler from '@rover/react-lib/src/apis/DefaultAPIErrorHandler';
import appendUrlParams from '@rover/rsdk/src/modules/Network/appendUrlParams';
import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import type { Snakeify } from '@rover/rsdk/src/modules/Network/object-utilities';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import { fullApiUrl } from '@rover/utilities/apiUrl';

const camelGet = async <T>({
  url,
  queryParams,
}: {
  url: string;
  queryParams?: Record<string, string>;
}): Promise<T> => {
  const fullUrl = fullApiUrl(url);
  const urlWithParams = queryParams ? appendUrlParams(fullUrl, queryParams) : fullUrl;
  const ai = getAxiosInstance();

  try {
    const { data } = await ai.get<Snakeify<T>>(urlWithParams);
    return camelize(data, true) as unknown as T;
  } catch (error: any) {
    return DefaultAPIErrorHandler(error, `There was an error fetching ${url}`);
  }
};

export default camelGet;
